var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrafficLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0325 2.0325L16.98 1.98C16.7937 1.61372 16.5107 1.30544 16.1617 1.08861C15.8126 0.871779 15.4109 0.754674 15 0.75H6.75V2.25H14.7675L9.96 7.38C9.83719 7.51173 9.68858 7.61677 9.52342 7.68859C9.35827 7.76042 9.1801 7.79748 9 7.79748C8.8199 7.79748 8.64173 7.76042 8.47658 7.68859C8.31142 7.61677 8.16281 7.51173 8.04 7.38L3.2325 2.25H5.25V0.75H0.75V5.25H2.25V3.3975L6.945 8.4C7.20573 8.68561 7.52314 8.91374 7.87697 9.06983C8.23079 9.22591 8.61327 9.30653 9 9.30653C9.38673 9.30653 9.76921 9.22591 10.123 9.06983C10.4769 8.91374 10.7943 8.68561 11.055 8.4L15.75 3.3975V15.33C15.75 15.4414 15.7057 15.5482 15.627 15.627C15.5482 15.7057 15.4414 15.75 15.33 15.75H2.67C2.55861 15.75 2.45178 15.7057 2.37302 15.627C2.29425 15.5482 2.25 15.4414 2.25 15.33V6.75H0.75V15.33C0.75 15.8392 0.952285 16.3276 1.31235 16.6876C1.67242 17.0477 2.16078 17.25 2.67 17.25H15.33C15.8392 17.25 16.3276 17.0477 16.6876 16.6876C17.0477 16.3276 17.25 15.8392 17.25 15.33V3C17.2504 2.66534 17.1761 2.33481 17.0325 2.0325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficLink);
export default __webpack_public_path__ + "static/media/traffic-link.844fabc51c0576711a15b4bccac2b002.svg";
export { ForwardRef as ReactComponent };